export default __webpack_public_path__ + "static/hrsm-627f1ec083d14edfe3d04ef4990577db.png";